<div class="bv-topbar__left">
  @if (topbarContext) {
    <div class="bv-topbar__context">
      <span class="bv-topbar__context-title">{{ topbarContext.title }}</span>
      @if (topbarContext.badge) {
        <span class="bv-topbar__context-badge">{{ topbarContext.badge }}</span>
      }
      @if (topbarContext.subtitle) {
        <span class="bv-topbar__context-sep">—</span>
        <span class="bv-topbar__context-subtitle">{{ topbarContext.subtitle }}</span>
      }
      @if (topbarContext.actions?.length) {
        <div class="bv-topbar__context-actions">
          @for (action of topbarContext.actions; track action) {
            <button class="bv-topbar__context-action"
              [class.bv-topbar__context-action--danger]="action.type === 'danger'"
              [class.bv-topbar__context-action--warning]="action.type === 'warning'"
              [class.bv-topbar__context-action--fav-on]="action.type === 'favorite-on'"
              [class.bv-topbar__context-action--fav-off]="action.type === 'favorite-off'"
              [class.bv-topbar__context-action--active]="action.active"
              [matTooltip]="action.tooltip"
              (click)="action.callback()">
              <mat-icon>{{ action.icon }}</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  } @else {
    <span class="bv-topbar__title">{{ pageTitle }}</span>
  }
</div>

<div class="bv-topbar__right">
  <button class="bv-topbar__btn" [matMenuTriggerFor]="langMenu">
    <span class="material-symbols-outlined bv-topbar__lang-icon">{{ selectedLanguage.symbol }}</span>
  </button>

  <mat-menu #langMenu="matMenu" xPosition="before">
    @for (item of languageSelector; track item) {
      <button mat-menu-item (click)="setLenguageBycountryCode(item)">
        <div class="bv-topbar__menu-item">
          <span class="material-symbols-outlined bv-topbar__lang-icon">{{ item.symbol }}</span>
          <span>{{ item.name }}</span>
        </div>
      </button>
    }
  </mat-menu>

  <button class="bv-topbar__btn" [matMenuTriggerFor]="profileMenu">
    <div class="bv-topbar__avatar">
      {{ userInfo?.email[0] | uppercase }}
    </div>
  </button>

  <mat-menu #profileMenu="matMenu" xPosition="before" class="bv-profile-menu">
    <div class="bv-profile__header" (click)="$event.stopPropagation()">
      <div class="bv-profile__avatar">
        {{ userInfo?.email[0] | uppercase }}
      </div>
      <div class="bv-profile__info">
        <span class="bv-profile__firm">{{ userInfo?.firm_name }}</span>
        <span class="bv-profile__email">{{ userInfo?.email }}</span>
        @if (roleLabelKey) {
          <span class="bv-profile__role">{{ roleLabelKey | translate }}</span>
        }
      </div>
    </div>

    @for (item of profileButtons; track item) {
      <button mat-menu-item class="bv-profile__item" (click)="onClickMenu(item.key)">
        <mat-icon>{{ item.matIcon }}</mat-icon>
        <span>{{ item.name | translate }}</span>
      </button>
    }

    <div class="bv-profile__divider"></div>

    <button mat-menu-item class="bv-profile__item bv-profile__item--logout" (click)="logOut()">
      <mat-icon>logout</mat-icon>
      <span>{{ 'USER_MENU.LOGOUT' | translate }}</span>
    </button>
  </mat-menu>
</div>
